import { Component, OnInit } from '@angular/core';
import { BsgHighContrastService } from '../services/bsg.service';

@Component({
	selector: 'app-high-contrast-toggle',
	template: `
		<button
			class="bsg-high-contrast-button"
			[class.bsg-high-contrast-active]="isHighContrast"
			(click)="toggleHighContrast()"
			(keydown.enter)="toggleHighContrast()"
			tabindex="0"
			role="switch"
			[attr.aria-checked]="isHighContrast"
			aria-label="Toggle high contrast mode"
		>
			<span class="bsg-high-contrast-icon"> </span>
			<span class="bsg-high-contrast-text">
				{{ isHighContrast ? 'Standard Mode' : 'High Contrast' }}
			</span>
		</button>
	`,
	styles: [
		`
			.bsg-high-contrast-button {
				display: flex;
				align-items: center;
				background: rgba(36, 31, 33, 0.6);
				border: 1px solid #f4ece1;
				border-radius: 24px;
				padding: 8px 14px;
				color: #f4ece1;
				cursor: pointer;
				transition: all 0.2s ease;
				font-family: AppFont, sans-serif;
				font-size: 14px;
			}

			.bsg-high-contrast-button:focus {
				outline: 2px solid #0078d7;
				box-shadow: 0 0 0 4px rgba(0, 120, 215, 0.25);
			}

			.bsg-high-contrast-active {
				background: #f4ece1;
				color: #241f21;
			}

			.bsg-high-contrast-icon {
				display: flex;
				align-items: center;
				margin-right: 8px;
			}

			.bsg-high-contrast-icon ion-icon {
				font-size: 20px;
			}

			/* Adapt for small screens */
			@media (max-width: 480px) {
				.bsg-high-contrast-text {
					display: none;
				}

				.bsg-high-contrast-button {
					padding: 8px;
				}

				.bsg-high-contrast-icon {
					margin-right: 0;
				}
			}
		`,
	],
})
export class HighContrastToggleComponent implements OnInit {
	isHighContrast = false;

	constructor(private highContrastService: BsgHighContrastService) {}

	ngOnInit() {
		this.isHighContrast = this.highContrastService.isHighContrast();
	}

	toggleHighContrast() {
		this.isHighContrast = this.highContrastService.toggleHighContrast();
	}
}
